// Shared across every proposal: the communication promise and the Easy Exit guarantee.
// Edit here once; every client's page picks it up.

export const communication = {
  weeklyReport: "Every week I send you a report: showing feedback, open house traffic, advertising stats and what the market is doing. You'll always know what I'm doing to sell your home and how buyers are responding.",
  followUp: "100% showing follow-up. My team chases down feedback so you're never left wondering.",
  exampleReport: {
    label: "Example report with sample numbers",
    week: "Week 1",
    showings: 9,
    openHouseVisitors: 34,
    onlineViews: 1240,
    feedback: ["Loved the yard and the quiet street.", "Great layout. We're talking with our agent about an offer."],
  },
  zillowInset: {
    file: "marketing/zillow-activity-week.webp",
    caption: "A real Zillow activity report from one of my listings.",
  },
};

export const promise = {
  statement: "If you're not happy with how things are going, you can cancel. No questions asked.",
  easyExit: "Your time and money are too valuable to risk on the wrong agent. That's why my listing agreement comes with an Easy Exit guarantee: if you're not satisfied with my service and results, you can cancel the listing.",
  points: [
    {
      title: "Courtesy",
      text: "No pushy sales tactics. When you call, I do my best to answer right away, and if I miss you, I call back fast.",
    },
    {
      title: "Weekly follow-up",
      text: "At least once a week you get a full update: showings, market trends, analytics and recent sales nearby.",
    },
    {
      title: "Aggressive marketing",
      text: "Old-fashioned hard work plus the latest tools: direct mail, brochures, web, social media and personal outreach.",
    },
    { title: "Accountability", text: "I deliver on promises, not empty talk, and I back it up in writing." },
    {
      title: "Great results",
      text: "Anyone can make promises. The real test is results, and I have hundreds of happy clients to prove it.",
    },
  ],
};
